import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import Vimeo from '@vimeo/player';
import { event } from 'jquery';

function pauseVideo(slider) {
    let iframe;
    iframe = slider.querySelectorAll('.container-slide iframe');

    if (iframe.length === 0) return;
    for (let i = 0; i < iframe.length; i++) {
        iframe[i].contentWindow.postMessage(JSON.stringify({ method: 'pause', value: 'true' }), '*');
    }
}

jQuery(function ($) {
    const $slick_slider = $('.block-slider');

    $slick_slider.slick();

    const iframes = document.querySelectorAll('.container-slide iframe');
    let player = [];
    let iframesVideo = document.querySelectorAll('.container-slide iframe');
    let played = false;

    iframes.forEach((iframe, key) => {
        player[key] = new Vimeo(iframe);

        if (played == false) {
            player[key].on('play', function () {
                if (iframesVideo.length === 0) return;
                for (let i = 0; i < iframesVideo.length; i++) {
                    if (key !== i) {
                        iframesVideo[i].contentWindow.postMessage(JSON.stringify({ method: 'pause', value: 'true' }), '*');
                    }
                }
            });
        }
    });

    $slick_slider.on('afterChange', function (event, slick, currentSlide) {
        pauseVideo(this);
    });

    $slick_slider.on('beforeChange', function (event, slick, currentSlide) {
        $(this)
            .find('.animated')
            .each(function () {
                $(this).css('opacity', 0);
                $(this).removeClass('animate');
                setTimeout(() => {
                    $(this).addClass('animate');
                }, 50);
            });
    });

    $slick_slider.on('setPosition', function (event, slick) {
        if ($(this).closest('.mo-slider').length && slick?.slideCount > 1) {
            setSlidesHeight(this);
            setDotsArrowsPosition(this, slick);
        }
    });

    // Set position of dots and arrows on mobile
    function setDotsArrowsPosition(slider, slick) {
        const $moSlider = $(slider);
        const contentHeight = $moSlider.find('.slide-text').first().outerHeight();
        const isMobile = window.innerWidth < 1024;
        const $slickDots = slick.$dots;
        const $nextArrow = slick.$nextArrow;
        const $prevArrow = slick.$prevArrow;
        
        if (isMobile && contentHeight) {
            if($slickDots){
                $slickDots.length && $slickDots.css('bottom', 'auto');
                $slickDots.length && $slickDots.css('top', `calc(${contentHeight}px - 1rem)`);
                $slickDots.length && $slickDots.css('transform', 'translateY(-100%)');
            }

            if($nextArrow){
                $nextArrow.length && $nextArrow.css('top', contentHeight);
                $nextArrow.length && $nextArrow.css('transform', 'translateY(-100%)');   
            }

            if($prevArrow){
                $prevArrow.length && $prevArrow.css('top', contentHeight);
                $prevArrow.length && $prevArrow.css('transform', 'translateY(-100%)');
            }
        }
    }

    // Set height of slides to be equal
    function setSlidesHeight(slider) {
        const $moSlider = $(slider);
        let $slidesEl = $moSlider.find('.slide-text');
        $slidesEl.each(function (index, el) {
            $(el).height('auto');
        });
        let maxHeight = -1;
    
        $slidesEl.each(function (index, el) {
            maxHeight = maxHeight > $(el).height() ? maxHeight : $(el).height();
        });
    
        $slidesEl.each(function (index, el) {
            $(el).height(maxHeight);
        });
    }
});
